const images = [
  "https://images.unsplash.com/photo-1596755389378-c31d21fd1273?auto=format&fit=crop&w=700&q=80",
  "https://images.unsplash.com/photo-1596462502278-27bfdc403348?auto=format&fit=crop&w=700&q=80",
  "https://images.unsplash.com/photo-1522335789203-aabd1fc54bc9?auto=format&fit=crop&w=700&q=80",
  "https://images.unsplash.com/photo-1612817288484-6f916006741a?auto=format&fit=crop&w=700&q=80",
];

const InstagramGallery = () => {
  return (
    <section className="instagram-section">
      <div className="section-container">
        <div className="section-heading center">
          <p>Follow the ritual</p>
          <h2>@luxeskin</h2>
        </div>

        <div className="instagram-grid">
          {images.map((image) => (
            <img key={image} src={image} alt="Skincare lifestyle" />
          ))}
        </div>
      </div>
    </section>
  );
};

export default InstagramGallery;
